/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRelease} from '../api'

 export const useQueryGetRelease = createReactQueryHook('getRelease', getRelease)
